export class XmlAttribute {
    key: string;
    value: string | null;

    constructor(key: string, value: string | null = null) {
        this.key = key;
        this.value = value;
    }
}
